/*
    <colgroup> 元素通常与 <col> 元素一起使用，
    可以通过 <col> 元素来指定每列的具体属性，也可以通过 <colgroup> 元素来指定一组列的公共属性。
    这样可以避免在每列的单元格中重复设置属性，简化了表格的代码结构，并且可以提高表格的性能。
  */
export function createColVnode (h, cols) {
  const colVnode = cols.reduce((pre, col) => {
    if (!col.children || !col.children.length) {
      const colItem = h('col', {
        attrs: {
          name: col.key,
          width: col.width,
          label: col.label
        }
      })
      pre = pre.concat([colItem])
    }
    return pre
  }, [])
  return colVnode
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/utils/col-vnode.js